const translations = {
	page_title: "Mon compte",
	my_informations: "Mes informations",
	password: "Mot de passe",
	my_signature: "Ma signature manuscrite",
	create_signature: "Créer une signature",
	modify_signature: "Modifier la signature",
	modify_password: "Modifier le mot de passe",
	change_password: "Changer de mot de passe",
	signature_info:
		"Votre signature manuscrite est requise pour réaliser des souscriptions. Elle sera utilisée sur les documents envoyés aux sociétés de gestion, sans que vous ayez à signer électroniquement.",
	password_requirements: {
		title: "Le mot de passe doit au moins contenir:",
		min_length: "12 caractères",
		lowercase: "Une minuscule",
		uppercase: "Une majuscule",
		number: "Un chiffre",
		special_character: "Un caractère spécial",
	},
	current_password: {
		label: "Mot de passe actuel",
		placeholder: "Entrer le mot de passe",
	},
	new_password: {
		label: "Nouveau mot de passe",
		placeholder: "Entrer le nouveau mot de passe",
	},
	confirm_new_password: {
		label: "Confirmer le mot de passe",
		placeholder: "Confirmer le mot de passe",
	},
};

export default translations;
